import { gql } from 'apollo-boost'

export const GET_USER_KEYS_DELIVERY_EVENT_INVITATIONS = gql`
  query GetUserKeysDeliveryEventInvitations {
    listUserKeysDeliveryEventInvitations {
      id
      isAttending
      keysDeliveryEvent {
        id
        caption
        date
        isPublished
        isCanceled
        construction {
          address
          name
        }
      }
    }
  }
`
